import { apiRequest } from './client.js';

/** One list-box entry under a branding subtype. */
export interface BrandingVariant {
  readonly optionId: string;
  readonly optionCode: string;
  readonly optionName: string;
  readonly displayOrder: number;
}

/**
 * A subtype's variant list. brandingItemId names the subtype it belongs to;
 * brandingTypeId instead means the list covers a whole branding type, which is
 * how one POP list serves every POP subtype.
 */
export interface BrandingVariantSet {
  readonly attributeId: string;
  readonly attributeCode: string;
  readonly attributeName: string;
  readonly dataType: string;
  readonly displayOrder: number;
  readonly brandingTypeId: string | null;
  readonly brandingItemId: string | null;
  readonly options: readonly BrandingVariant[];
}

const BASE = '/v1/m17/branding-variants';

export async function listBrandingVariantSets(
  token: string,
): Promise<readonly BrandingVariantSet[]> {
  const r = await apiRequest<{ data: BrandingVariantSet[] }>(BASE, { token });
  return r.data ?? [];
}

export async function addBrandingVariant(
  token: string,
  attributeId: string,
  body: { optionCode: string; optionName: string; displayOrder?: number },
): Promise<BrandingVariant> {
  const r = await apiRequest<{ data: BrandingVariant }>(
    `${BASE}/${attributeId}/options`,
    { method: 'POST', token, body },
  );
  return r.data;
}

export async function updateBrandingVariant(
  token: string,
  optionId: string,
  body: { optionName?: string; displayOrder?: number },
): Promise<BrandingVariant> {
  const r = await apiRequest<{ data: BrandingVariant }>(`${BASE}/options/${optionId}`, {
    method: 'PUT',
    token,
    body,
  });
  return r.data;
}

export async function archiveBrandingVariant(token: string, optionId: string): Promise<void> {
  await apiRequest(`${BASE}/options/${optionId}`, { method: 'DELETE', token });
}
